import React, { FC } from 'react';
import classNames from 'classnames';

import { ImagePreloader } from 'app/design-system/components/ImagePreloader';
import { getUniversalUrl } from 'app/lib/get-universal-url';

import styles from './InstructionImage.module.scss';

type FileName = 'ios_step_1' | 'ios_step_2' | 'installation_completed';
type FileExtension = 'png' | 'jpeg';

type InstructionImageProps = {
  fileName: FileName;
  fileExtension?: 'png' | 'jpeg';
  position?: 'start' | 'end';
};

const IMAGES_PATH = 'images/download-instruction';

const getInstructionImage = (fileName: FileName, fileExtension: FileExtension) => getUniversalUrl(`${IMAGES_PATH}/${fileName}.${fileExtension}`);

export const InstructionImage: FC<InstructionImageProps> = ({ fileName, position = 'end', fileExtension = 'png' }) => {
  const rootClassName = classNames(styles.root, {
    [styles.positionStart]: position === 'start',
  });

  const imageSrc = getInstructionImage(fileName, fileExtension);

  return (
    <div className={rootClassName}>
      <ImagePreloader className={styles.img}
                      imageSrc={imageSrc} />
    </div>
  );
};
